import api from "./api";

export interface GerenteOption {
  id: string;
  nome: string;
  email: string;
}

export interface UsuarioAtivo {
  id: string;
  nome: string;
  email: string;
  perfil: string;
  fotoUrl?: string | null;
  /** Função padrão da pessoa — pré-preenche a função ao alocá-la num card. */
  funcaoPadrao?: string | null;
}

export async function listarGerentes() {
  const response = await api.get("/usuarios/gerentes");
  return response.data.data as GerenteOption[];
}

export async function listarUsuariosAtivos() {
  const response = await api.get("/usuarios/ativos");
  return response.data.data as UsuarioAtivo[];
}
